__turbopack_context__.v({
  "className": "fontmono_d8d43543-module__4dEuia__className",
  "variable": "fontmono_d8d43543-module__4dEuia__variable",
});
